import { Piano } from "./piano/Piano";
import "./App.css";
import { Board } from "./board/Board";

function App() {
  return (
    <div className="App">
      <Piano />
    </div>
  );
}

export default App;
